import React, { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import SplashScreen from 'src/components/elements/SplashScreen';
import {
  verifyAccessTokenStart,
  verifyAccessTokenSuccess,
  verifyAccessTokenError
} from '../store/reducers/authReducer';

const isValidToken = accessToken => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

const setSession = accessToken => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
  } else {
    localStorage.removeItem('accessToken');
  }
};

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isInitialised } = useSelector(state => state.auth);

  useEffect(() => {
    const initialise = async () => {
      try {
        dispatch(verifyAccessTokenStart());
        const accessToken = window.localStorage.getItem('accessToken');
        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          const tokenDecode = jwtDecode(accessToken);

          dispatch(verifyAccessTokenSuccess(tokenDecode));
        } else {
          dispatch(verifyAccessTokenError());
        }
      } catch (err) {
        console.error(err);
        dispatch(verifyAccessTokenError());
      }
    };

    initialise();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isInitialised) {
    return <SplashScreen />;
  }

  return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
};

export default AuthContext;
